import { getZerothMinuteOfDayInTimezone } from '../incremental-options-utils/get-zeroth-minute-of-day-in-timezone';
import { MILLISECONDS_IN_DAY } from '../incremental-options-utils/time-constants';
import timezoneMap from '../timezone-name-map.json' with { type: 'json' };

export const getLocalAdjustedZerothDate = (
  date: Date,
  zonedOffsetMilliseconds: number,
  selectedTimezone: keyof typeof timezoneMap,
  machineOffsetMilliseconds: number
): number => {
  return (
    getZerothMinuteOfDayInTimezone(date.getTime() - zonedOffsetMilliseconds, selectedTimezone) +
    (machineOffsetMilliseconds > 0 ? MILLISECONDS_IN_DAY : 0)
  );
};
